import React, { useState } from 'react';
import './PC.css';

const PC = () => {
    const [walls, setWalls] = useState([
        { id: 1, height: '', width: '' },
        { id: 2, height: '', width: '' }
    ]);
    const [totalPaintNeeded, setTotalPaintNeeded] = useState(0.00);
    const calculatePaint = (currentWalls) => {
        const COVERAGE_RATE = 10;
        const totalArea = currentWalls.reduce((sum, wall) => {
            const h = parseFloat(wall.height) || 0;
            const w = parseFloat(wall.width) || 0;
            return sum + (h * w);
        }, 0);
        const paintLiters = totalArea / COVERAGE_RATE;
        setTotalPaintNeeded(paintLiters.toFixed(2));
    };
    const handleInputChange = (id, field, value) => {
        const newWalls = walls.map(wall => {
            if (wall.id === id) {
                return { ...wall, [field]: value };
            }
            return wall;
        });
        setWalls(newWalls);
        calculatePaint(newWalls);
    };
    const handleAddWall = () => {
        const newWall = {
            id: walls.length + 1,
            height: '',
            width: ''
        };
        setWalls([...walls, newWall]);
    };
    const handleRemoveWall = (id) => {
        if (walls.length <= 2) {
            const newWalls = walls.map(wall =>
                wall.id === id ? { ...wall, height: '', width: '' } : wall
            );
            setWalls(newWalls);
            calculatePaint(newWalls);
            return;
        }
        const newWalls = walls.filter(wall => wall.id !== id);
        setWalls(newWalls);
        calculatePaint(newWalls);
    };
    return (
        <div className="paint-calculator-container">
            <div className="pc-intro">
                <h2 className="main-header">Find Your Paint Quantity in Seconds</h2>
                <p className="subheader">
                    Enter your room details and let our smart calculator guide you to the ideal amount of Rungdo paint for a smooth and cost-efficient finish.
                </p>
            </div>
            <div className="pc-stage">
                <div className="pc-stack-card">
                    <div className="callout-box">
                        <h3 className="callout-title">Paint Calculator</h3>
                        <p className="callout-text">
                            Paint calculator simplifies your project by accurately measuring the needed paint, making painting easier.
                        </p>
                    </div>
                    <div className="calculator-form">
                        {walls.map((wall, index) => (
                            <div key={wall.id} className="wall-inputs-row">
                                <div className="input-group">
                                    <label htmlFor={`height-${wall.id}`}>{index === 0 ? 'Height (m):' : 'Height (meters):'}</label>
                                    <input
                                        id={`height-${wall.id}`}
                                        type="number"
                                        placeholder="Enter height"
                                        value={wall.height}
                                        onChange={(e) => handleInputChange(wall.id, 'height', e.target.value)}
                                        min="0"
                                    />
                                </div>
                                <div className="input-group">
                                    <label htmlFor={`width-${wall.id}`}>{index === 0 ? 'Width (m):' : 'Width (meters):'}</label>
                                    <input
                                        id={`width-${wall.id}`}
                                        type="number"
                                        placeholder="Enter width"
                                        value={wall.width}
                                        onChange={(e) => handleInputChange(wall.id, 'width', e.target.value)}
                                        min="0"
                                    />
                                </div>
                            </div>
                        ))}
                        <div className="actions-row">
                            <button
                                className="action-button pc-remove-btn"
                                onClick={() => handleRemoveWall(walls[walls.length - 1].id)}
                                disabled={walls.length <= 2}
                            >
                                Remove
                            </button>
                            <button
                                className="action-button pc-add-wall-btn"
                                onClick={handleAddWall}
                            >
                                Add New Wall
                            </button>
                            <div className="action-button pc-quantity-display-btn">
                                Quantity(Ltr) of Paint Needed {totalPaintNeeded} Ltr
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PC;
